<template>
  <div class="transaction-row-container" :class="{'editable': isTransactionEditable}">
    <div>
      <div class="transaction-row">
        <div class="name">{{ transaction.businessName }}</div>
      </div>
      <div class="amounts-row">
        <div class="actual-amount">{{ formatAmount(getTransactionAmount(transaction)) }}</div>
        <div class="predicted-amount-spacer"></div>
      </div>
      <div class="more-details">
        <img class="icon" :src="require('@/assets/subdirectory-arrow-left@3x.png')">
        <span>{{ formatDate(transaction.transactionDate) }}</span>
        <span class="business-name">{{ transaction.businessName }}</span>
        <span>{{ getTransactionPayment(transaction) }}</span>
        <span>{{ getTransactionAccount(transaction) }} </span>
      </div>
    </div>
    <div class="three-dots" v-if="isTransactionEditable" :class="{ selected: isSelected }">
      <img :src="require('@/assets/icons/light-three-dots.svg')" v-if="isSelected">
      <img :src="require('@/assets/icons/three-dots.svg')" v-else>
    </div>
  </div>
</template>

<script>
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';

export default {
  name: 'TransactionRow',
  mixins: [TransactionDisplayUtils],
  props: [
    'transaction',
    'canEditCategory',
    'categoryName',
    'categoryId',
    'isSelected',
  ],
  computed: {
    isTransactionEditable() {
      return this.canEditCategory;
    },
  },
  methods: {
    getTransactionPayment(transaction) {
      return transaction.paymentNumber > 0 ? `- תשלום${transaction.paymentNumber}/${transaction.totalNumberOfPayments}` : '';
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-row-container {
    --pencil-bg-color: $riseup_white_1;
    padding: 8px 10px 4px 4px;
    transition: background-color 1s ease;
    display: flex;
    justify-content: space-between;

    &.editable {
      cursor: pointer;
    }

    &.highlight {
      background-color: $riseup_gray_1;
    }

    .transaction-row {
      display: flex;
      height: 15px;
      font-size: 10px;
      line-height: 1;
    }

    .amounts-row {
      display: flex;
      padding-right: 90px;
      font-weight: bold;
      height: 15px;
      line-height: 1;
      font-size: 10px;

      .actual-amount {
        width: 88px;
        font-weight: bold;
      }

      .predicted-amount-spacer {
        width: 60px;
      }
    }

    .three-dots {
      padding: 12px 0 0 15px;
      color: $riseup_gray_3;
    }

    .more-details {
      display: flex;
      white-space: nowrap;
      height: 18px;
      font-size: 10px;
      line-height: 1;
      color: $riseup_gray_3;

      span {
        overflow: hidden;
        padding-left: 2px;
      }

      .business-name {
        max-width: 126px;
      }

      .icon {
        margin-top: 2px;
        padding-left: 2px;
        height: 6px;
      }
    }
  }
</style>
